/*
 *  -----------------------------------------------------------------------
 *    <copyright file="settings.ts" company="Triumph Research Intelligence">
 *        Copyright (C) 2019 by Triumph Research Intelligence. All rights reserved.
 *    </copyright>
 *   -----------------------------------------------------------------------
 *
 */

interface ISettings {
    token: string | null;
    api: {
        graphQlUrl: () => string;
        restUrl: () => string;
        graphQlWebSocketUrl: () => string;
        url: () => string;
        webSocketUrl: () => string;
        reportingHubUrl: () => string;
        frontendMessageHubUrl: () => string;
        frontendMessageHubVersionUrl: () => string;
    };
}

const Settings: ISettings = {
    token: null,
    api: {
        graphQlUrl: () => `${Settings.api.url()}/api/graphql`,

        graphQlWebSocketUrl: () =>
            window.location.hostname !== 'localhost'
                ? `${window.location.protocol.toLowerCase() === 'http:' ? 'ws' : 'wss'}://${
                      window.location.hostname
                  }/graphql`
                : 'wss://localhost:44352/graphql',

        url: () =>
            window.location.hostname !== 'localhost'
                ? `${window.location.protocol}//${window.location.hostname}`
                : 'https://localhost:44352',

        restUrl: () =>
            window.location.hostname !== 'localhost'
                ? `${window.location.protocol}//${window.location.hostname}/bff-api`
                : 'https://localhost:4101/bff-api',

        webSocketUrl: () =>
            window.location.hostname !== 'localhost'
                ? `${window.location.protocol.toLowerCase() === 'http:' ? 'ws' : 'wss'}://${window.location.hostname}`
                : 'wss://localhost:44352',

        reportingHubUrl: () =>
            window.location.hostname !== 'localhost'
                ? `${window.location.protocol.toLowerCase() === 'http:' ? 'ws' : 'wss'}://${
                      window.location.hostname
                  }/bff-api`
                : 'wss://localhost:4101/bff-api',

        frontendMessageHubUrl: () =>
            window.location.hostname !== 'localhost'
                ? `${window.location.protocol.toLowerCase() === 'http:' ? 'ws' : 'wss'}://${window.location.hostname}/frontend-message-hub`
                : 'wss://localhost:4201/frontend-message-hub',

        frontendMessageHubVersionUrl: () =>
            window.location.hostname !== 'localhost'
                ? `${window.location.protocol}//${window.location.hostname}/frontend-message-hub/appVersion`
                : 'https://localhost:4201/frontend-message-hub/appVersion',
    },
};

export default Settings;
